import { ADD_ADMIN_ORDERS_BY_EVENTS, ADMIN_GET_USERS_BY_EVENTS } from './actions';

const INITIAL_STATE = {
     ordersEvents: [],
};

const productEventsReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case ADD_ADMIN_ORDERS_BY_EVENTS: {
               return { ...state, ordersEvents: action.payload };
          }
          case ADMIN_GET_USERS_BY_EVENTS: {
               return { ...state, adminUsersByEvent: action.payload };
          }
          default:
               return state;
     }
};
export default productEventsReducer;
